import { CountryNamedLocation, IpNamedLocation, NamedLocation } from '@microsoft/microsoft-graph-types-beta';
import { createAction, props } from '@ngrx/store';

export const loadNamedLocations = createAction(
    '[Graph/Named Locations] Load Named Locations Policies ',
    props<{ _tenant: string }>(),
);

export const loadNamedLocationsSuccess = createAction(
    '[Graph/Named Locations] Load Named Locations Policies Success',
    props<{ _tenant: string; polices: (CountryNamedLocation & IpNamedLocation)[] }>(),
);

export const loadNamedLocationsFailure = createAction(
    '[Graph/Named Locations] Load Named Locations Policies Failure',
    props<{ _tenant: string; error: any }>(),
);

export const createNamedLocation = createAction(
    '[Graph/Named Locations] Create Named Location',
    props<{ _tenant: string; location: NamedLocation }>(),
);

export const createNamedLocationSuccess = createAction(
    '[Graph/Named Locations] Create Named Location Success',
    props<{ _tenant: string; location: NamedLocation }>(),
);

export const createNamedLocationFailure = createAction(
    '[Graph/Named Locations] Create Named Location Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateNamedLocation = createAction(
    '[Graph/Named Locations] Update Named Location',
    props<{ _tenant: string; location: NamedLocation }>(),
);

export const updateNamedLocationSuccess = createAction(
    '[Graph/Named Locations] Update Named Location Success',
    props<{ _tenant: string; location: NamedLocation }>(),
);

export const updateNamedLocationFailure = createAction(
    '[Graph/Named Locations] Update Named Location Failure',
    props<{ _tenant: string; error: any }>(),
);

export const deleteNamedLocation = createAction(
    '[Graph/Named Locations] Delete Named Location',
    props<{ _tenant: string; id: string }>(),
);

export const deleteNamedLocationSuccess = createAction(
    '[Graph/Named Locations] Delete Named Location Success',
    props<{ _tenant: string; id: string }>(),
);

export const deleteNamedLocationFailure = createAction(
    '[Graph/Named Locations] Delete Named Location Failure',
    props<{ _tenant: string; error: any }>(),
);
